import { BREAKPOINTS, useScreenSizes } from '@che-ins-ui/theme';
export const useIsModalScreenSize = () => {
    const { width } = useScreenSizes();
    return width <= BREAKPOINTS.lg;
};
